import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getIsSearchTableShown from 'mini-mail-list-store/lib/utils/getIsSearchTableShown';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import isFolderOrSubFolderOfDistinguishedFolder from '../isFolderOrSubFolderOfDistinguishedFolder';
import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';

/**
 * To identify if we've to junk a conversation item or not junk
 * we check:
 * We will not junk (return false)
 * a. in search folder with search filter as junkemail folder
 * b. or if in junk folder
 */
const getIsJunkValueToSet = (): boolean => {
    const isSearchTableShown = getIsSearchTableShown();
    const selectedTableView = getSelectedTableView();

    if (isSearchTableShown) {
        /**
         * if in search with search filter as junkemail folder
         */
        return !(
            (selectedTableView.tableQuery as SearchTableQuery).searchFolderScopeId ===
            folderNameToId('junkemail')
        );
    } else {
        /**
         * if in junk folder
         */
        return !isFolderOrSubFolderOfDistinguishedFolder(
            selectedTableView.tableQuery.folderId,
            'junkemail'
        );
    }
};

export default getIsJunkValueToSet;
